import {Middleware} from 'redux'
import {captureException} from '../errors'
import ServerError from '../errors/server'
import {AppDispatch, AppState} from '../store/store'

const middleware: Middleware<Record<string, unknown>, AppState, AppDispatch> =
  () => next => action => {
    try {
      // Send Flux Standard Action errors to Sentry
      if (
        typeof action === 'object' &&
        action !== null &&
        'error' in action &&
        action.error === true &&
        'payload' in action &&
        action.payload instanceof Error
      ) {
        const error = action.payload
        if (
          !ServerError.isServerError(error) ||
          (ServerError.isServerError(error) &&
            error.status >= 500 &&
            error.status < 600)
        ) {
          captureException(error)
        }
      }
      return next(action)
    } catch (err) {
      // Send errors thrown during dispatch to Sentry
      captureException(err)
      throw err
    }
  }

export default middleware
